import { useAuth } from '../../contexts/AuthContext/AuthContext'

export default function Employees() {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return (
      <div>
        <h1>Authentication Required</h1>
        <p>Please log in to access employees.</p>
      </div>
    )
  }

  return (
    <div>
      <h1>Employees</h1>
      <p>Welcome to your employees!</p>
    </div>
  )
} 